import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getCountries(businessUnitCode) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/location/countries",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            businessUnitCode: businessUnitCode,
        },
    });

    return response.data;
}
export async function getStates({businessUnitCode, countryCode}) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/location/states",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            businessUnitCode,
            countryCode,
        },
    });

    return response.data;
}
// POST /api/v3/shared/address/validate
export async function validateAddress({address1, address2, city, state, postalCode, country}) {
    const response = await axios({
        url: API_DOMAIN + "/api/v3/shared/address/validate",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: {address1, address2, city, state, postalCode, country},
    });

    return response.data;
}
